import React from "react";
import CustomFileUpload from "../../common/custom-file-upload/custom-file-upload";
//import DashboardFilters from "../dashboard/dashboard-filters/dashboard-filters";
import Layout from "../../layout/layout.js";

import "./upload-csv.css";
const UploadCsvPage = () => {
  const onFileChange = (files) => {
    //console.log(files);
  };
  return (
    <div className="dashbord-container w-100  h-100 px-3">
      {/* <div className="dashbord-page-filters">
        <DashboardFilters></DashboardFilters>
      </div> */}
      <div className="dash-heading">Upload your CSV file</div>
      <div className="dashbord-page-content upload-container">
        <div className="upload-content">
          <h3>New Dataset</h3>
          <CustomFileUpload
            url="https://ai-workbench.aisf.t-systems.net/api/upload-custom-csv/v1/upload-csv/"
            onFileChange={(files) => onFileChange(files)}
          ></CustomFileUpload>
        </div>
      </div>
    </div>
  );
};

export default UploadCsvPage;
